import React, { FC } from 'react'
import styled from 'styled-components'
import { CancelOutlined } from '@mui/icons-material'

interface Props {
  color: string
  onClick: () => void
}

export const CloseIcon: FC<Props> = ({ color, onClick }) => (
  <Button onClick={onClick}>
    <CancelOutlined style={{ fontSize: '2.6rem', color }} />
  </Button>
)

const Button = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
`
